import { useState, useEffect } from "react";

import AuthContext from "./Auth/AuthContext";
import authStorage from "./Auth/Storage";
import AdminRoute from "./Routes/AdminRoute";
import AuthRoute from "./Routes/AuthRoute";

function App() {
  const [user, setUser] = useState(null);
  const [rank, setRank] = useState("");

  function restoreUser() {
    const userName = authStorage.getUser();
    if (!userName) return;

    const { username, rank } = JSON.parse(userName);
    setUser(username);
    setRank(rank);
  }

  useEffect(() => {
    restoreUser();
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {user ? (
        <>{rank === "Admin" ? <AdminRoute /> : <AuthRoute />}</>
      ) : (
        <AuthRoute />
      )}
    </AuthContext.Provider>
  );
}

export default App;
